import { render, staticRenderFns } from "./CustomerInfoAI.vue?vue&type=template&id=ef4a82e0&scoped=true"
import script from "./CustomerInfoAI.vue?vue&type=script&lang=js"
export * from "./CustomerInfoAI.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfoAI.vue?vue&type=style&index=0&id=ef4a82e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4a82e0",
  null
  
)

export default component.exports